import {makeStyles} from '../../theme'

export const useStyles = makeStyles(theme => ({
  root: {
    color: theme.go.schemes.colors.system.TextSuccess,
  },
  login: {
    fontSize: 20,
    fontWeight: 400,
    lineHeight: `${theme.go.schemes.components.header.height}px`,
    color: theme.go.schemes.colors.system.TextMinor,
    whiteSpace: 'nowrap',
  },
  avatar: {
    color: 'black',
  },
  pointer: {
    cursor: 'pointer',
  },
  paper: {
    zIndex: 10000,
    ...theme.go.mixins.paper,
    fontFamily: theme.typography.fontFamily, // Лечим отсутсвие шрифта из go в других сервисах
    fontSize: theme.typography.fontSize,
  },
  image: {
    width: 42,
    height: 42,
    verticalAlign: 'middle',
    borderRadius: '50%',
    overflow: 'hidden',
    position: 'relative',
    // https://gist.github.com/ayamflow/b602ab436ac9f05660d9c15190f4fd7b
    '-webkit-mask-image': '-webkit-radial-gradient(white, black)',
  },
  flexCenter: {
    display: 'flex',
    alignItems: 'center',
  },
  divider: {
    borderBottomStyle: 'solid',
    borderBottomColor: theme.go.schemes.colors.system.Divider,
    padding: theme.spacing(1.5),
    borderBottomWidth: 1,
    '&:last-child': {
      borderBottomWidth: 0,
    },
  },
  noBottomPadding: {
    paddingBottom: 0,
  },
  auth: {
    verticalAlign: 'middle',
  },
  noPointerEvents: {
    pointerEvents: 'none',
  },
  camera: {
    position: 'absolute',
    left: 0,
    bottom: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.5)',
    textAlign: 'center',
    lineHeight: '49px',
    transform: 'translateY(60%)',
    transition: 'transform 0.2s ease',
    pointerEvents: 'auto',
    color: 'white',
    zIndex: 0,
    '& svg': {
      transformOrigin: '50% 50%',
      transform: 'translateY(-90%)',
      transition: 'transform 0.2s ease',
      margin: '0 auto',
    },
    '&:hover': {
      transform: 'translateY(0)',
    },
    '&:hover svg': {
      transform: 'translateY(0) scale(150%)',
    },
  },
  noWrap: {
    whiteSpace: 'nowrap',
  },
  overflowShadow: {
    boxShadow: '5px -1px 30px rgb(215 215 215)',
  },
}))

export const useListItemStyles = makeStyles(theme => ({
  listItem: {
    pointerEvents: ({isCurrent}: {isCurrent: boolean}) => (isCurrent ? 'none' : 'visible'),
    paddingBottom: theme.spacing(0.5),
    whiteSpace: 'nowrap',
  },
}))
